module.exports = __webpack_public_path__ + "static/media/instaIcon.0634a5ba.png";